import {Component, ComponentRef} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Observer} from "rxjs";
import {FUIAlert, FUIAlertAction, FUIAlertActions, FUIAlertInputType, FUIAlertType} from "./alert.model";

@Component({
    animations: [
        trigger("fade", [
            state("void", style({
                opacity: 0
            })),
            state("true", style({
                opacity: 1
            })),
            transition("* => *", animate("450ms 0s ease"))
        ])
    ],
    selector: "fui-alert",
    styleUrls: ["./alert.component.scss"],
    templateUrl: "./alert.component.html",
    standalone: false
})
export class FUIAlertComponent {

    FuiAlertType = FUIAlertType;
    FUIAlertInputType = FUIAlertInputType;

    public alert: FUIAlert;
    public callback: Observer<FUIAlertAction>;
    public componentRef: ComponentRef<FUIAlertComponent>;
    public state: boolean = true;
    public inputs: any = {};

    constructor() {
    }

    clickAction(action: FUIAlertAction): void {
        if (action !== FUIAlertActions.CANCEL_ACTION) {
            if (this.alert.inputs && this.alert.inputs.length) {
                for (const input of this.alert.inputs) {
                    if (input.required && !this.inputs[input.name]) {
                        return;
                    }
                }
                action = {
                    name: action.name,
                    label: action.label,
                    inputs: this.inputs
                };
            }
        }
        this.callback.next(action);
        this.callback.complete();
        this.componentRef.destroy();
    }
}
